var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-bed"},[_c('div',{staticClass:"img-bed"},[_c('black-bar',{attrs:{"title":"操作说明"}})],1),_c('img',{attrs:{"src":require("../assets/img/noAccess/btn_more@3x.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }